import React, { memo } from 'react';
import { StyleSheet, View, ViewStyle } from 'react-native';
import Toast, { ToastProps, ToastShowParams } from 'react-native-toast-message';
import { isMobile } from '@/utils/general/device-info';

interface MB_ShowToastProps extends ToastProps {
  /**
   * If set to true, toast will show absolute to the top of the screen on web and will not be affected
   * by scroll.
   */
  absolutePositionForWeb?: boolean;
}

const mbShowToast = (params: ToastShowParams) => {
  Toast.show(params);
};

const mbHideToast = () => {
  Toast.hide();
};

const MB_Toast = memo(({ absolutePositionForWeb, ...props }: MB_ShowToastProps) => {
  if (!isMobile && absolutePositionForWeb) {
    return (
      <View style={styles.toastWrapperForWeb}>
        <Toast {...props} />
      </View>
    );
  }

  return <Toast {...props} />;
});

export { mbShowToast, mbHideToast, MB_Toast };
export type { MB_ShowToastProps };

const styles = StyleSheet.create({
  // TODO: Need to find a better way to handle this. RNW does support fixed but typescript still shows error
  toastWrapperForWeb: { position: 'fixed', width: '100%' } as unknown as ViewStyle,
});
